import type { Environment } from "./Environment"
import { parseEnvironment } from "./parseEnvironment"

/**
 * Examines the current window.location.host and returns the Environment of the application.
 * @returns The current Environment. Returns null of the environment is unknown, like localhost or other dev stages.
 */
export function currentEnvironment(): Environment | null {
	if (!window?.location) {
		return null
	}
	return parseEnvironment(window.location.host)
}
